import styled, { css } from 'styled-components';
import FloatingButton from '@/components/FloatingButton';
import store from '@/store';
import { SMARTPHONE } from '@/constants';
import { colors } from '@/globalStyles';

export const ButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img`
  width: 50px;
  height: 50px;
`;

export const IconWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const NavInfoWrap = styled.div`
  position: absolute;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  height: 50px;
  display: flex;
  align-items: center;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          bottom: 10px;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const NavInfo = styled.div`
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;

  color: #ffffff;
  opacity: 0.9;
  border-radius: 17.5px;
  background-color: #373737;
  padding: 8px 25px;
`;

export const LeftFloatingButton = styled(FloatingButton)`
  left: 20px;
  bottom: 20px;
  width: 50px;
  height: 50px;
  border-radius: 25px;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          left: 10px;
          bottom: 10px;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const RightFloatingButton = styled(FloatingButton)`
  right: 20px;
  bottom: 20px;
  width: 50px;
  height: 50px;
  border-radius: 25px;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          right: 10px;
          bottom: 10px;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const LeftArrowButtonWrapperStyled = styled.div`
  position: absolute;
  z-index: 100;
  left: 50px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: ${colors.white};
  border-radius: 50%;
  cursor: pointer;
`;

export const RightArrowButtonWrapperStyled = styled.div`
  position: absolute;
  z-index: 100;
  right: 50px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: ${colors.white};
  border-radius: 50%;
  cursor: pointer;
`;

export const NavInfoWrapperStyled = styled.div`
  position: absolute;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  height: 25px;
  display: flex;
  align-items: center;
  cursor: ${props => props.$clickable? 'pointer' : 'unset'};
`;

export const NavInfoStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.white};
  border-radius: 50px;
  background-color: ${colors.black};
  width: 70px;
  height: 100%;
`;

export const NavInfoGoToPageStyled = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  grid-gap: 25px;
  width: auto;
  height: auto;
  padding: 25px;
`;

export const NavInfoGoToPageLabelStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: SourceSansPro;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202020;
`;

export const NavInfoGoToPageInputStyled = styled.input`
  width: 68px;
  height: 36px;
  flex-grow: 0;
  margin: 0 0 0 15px;
  padding: 10px;
  border-radius: 2px;
  border: solid 1px ${colors.primary};
  background-color: white;
  &:focus {
    outline: none;
  }
`;